import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { Appointment } from '../appointment';


const MAX_LENGTH: number = 6000;

@Component({
  selector: 'mc-appointment-form-field',
  templateUrl: './appointment-form-field.component.html',
  styleUrls: ['./appointment-form-field.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => AppointmentFormFieldComponent),
    multi: true
  }]
})
export class AppointmentFormFieldComponent implements ControlValueAccessor {

  @Input() label: string;
  @Input() _model: any;
  _value: any;

  constructor() { }

  get value(): any {
    return this._value;
  }

  changedEditor(event): void {
    if (event && event.html) {
      if (event.html.length > MAX_LENGTH) {
        event.editor.deleteText(MAX_LENGTH, event.editor.getLength());

      } else {
        this.propagateChange(event.html);
      }
    }
  }

  propagateChange: any = () => {};

  writeValue(value: any): void {
    if (value) {
      this._value = value;
    }
    this.onChange(this._model);
  }

  registerOnChange(fn): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: () => void): void {}

  onChange(event) {
    if (event && event.target) {
      this.propagateChange(event.target.value);
    }
  }
}
